import { cloneDeep } from 'lodash';

const loadEvents = (state, payload) => {
  const newState = cloneDeep(state);
  try {
    if (payload.error) {
      newState.error = true;
      return newState;
    }
    newState.activeEvents = { ...newState.activeEvents, ...payload.orders };
    const { callId__call } = payload.calls;
    const pointIdCalls = {};
    for (const callId in callId__call) {
      const call = callId__call[callId];
      if (!pointIdCalls[call.pointId]) {
        pointIdCalls[call.pointId] = [];
      }
      pointIdCalls[call.pointId].push(call);
    }
    newState.calls = { ...newState.calls, ...pointIdCalls };
    newState.users = payload.users;
    newState.loading = false;
    newState.initialized = payload.initialized;
    return newState;
  } catch (error) {
    return state;
  }
  
};

export { loadEvents };
